// src/supabaseClient.js
// ─────────────────────────────────────────────────────────
// Este arquivo cria a conexão com o Supabase.
// As chaves vêm do arquivo .env (nunca coloque as chaves direto aqui!)
// ─────────────────────────────────────────────────────────

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error(
    "⚠️  ATENÇÃO: Variáveis de ambiente do Supabase não configuradas!\n" +
    "Crie um arquivo .env na raiz do projeto com:\n" +
    "REACT_APP_SUPABASE_URL=...\n" +
    "REACT_APP_SUPABASE_ANON_KEY=..."
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
